import React from "react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"

import type { SwitchProps } from "./switch.interfaces"
import { SwitchContainer } from "./switch.styled"

const Switch: React.FC<SwitchProps> = React.memo(
  ({ checked, onChange, size = "md" }) => {
    const roomStyles = useRecoilValue(brandingSelector)

    return (
      <SwitchContainer
        roomStyles={roomStyles}
        isChecked={checked}
        onChange={onChange}
        size={size}
      />
    )
  }
)

export default Switch
